module.exports = __webpack_public_path__ + "img/2.77722f5e.png";